







import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MovieContentsTexts extends Vue {
  @Prop({ default: null }) title: string;
  @Prop({ default: null }) textContentsHtml: string;
}
